import { EditableDataGrid } from "../../../builderPackage/components/editableDataGrid/editableDataGrid";
export var ParameterBeforeRepair = function (props) {
    var _value$ParamsBeforeRe, _value$ParamsBeforeRe2, _value$ParamsBeforeRe3;
    var value = props.value, onChange = props.onChange;
    var columns = [{
            type: "singleSelect",
            field: "SerialNo",
            headerName: "Parameter No",
            editable: false,
            minWidth: 100,
            renderCell: function (params) { return params.api.getAllRowIds().indexOf(params.id) + 1; }
        }, {
            type: "string",
            field: "CheckedParams",
            headerName: "Parameters Checked",
            editable: true,
            minWidth: 400,
            flex: 1
        }, {
            type: "string",
            field: "Observations",
            headerName: "Observations",
            editable: true,
            minWidth: 400,
            flex: 1
        }];
    return /*#__PURE__*/ React.createElement(EditableDataGrid, {
        columns: columns,
        rows: value === null || value === void 0 ? void 0 : value.ParamsBeforeRepairData,
        dataGridHeader: "Parameter Before Repair",
        validationModel: {
            CheckedParams: function (value) {
                var leadingSpacesRegex = /^\S.*$/;
                if (!leadingSpacesRegex.test(value) && (value === null || value === void 0 ? void 0 : value.length) > 0) {
                    return "Leading spaces are not allowed.";
                }
                if (!value || (value === null || value === void 0 ? void 0 : value.length) < 10 || (value === null || value === void 0 ? void 0 : value.length) > 250) {
                    return "Parameters length must be between 10 and 250 characters.";
                }
                else if ((value === null || value === void 0 ? void 0 : value.length) > 10) {
                    return '';
                }
                return '';
            },
            Observations: function (value) {
                var leadingSpacesRegex = /^\S.*$/;
                if (!leadingSpacesRegex.test(value) && (value === null || value === void 0 ? void 0 : value.length) > 0) {
                    return "Leading spaces are not allowed.";
                }
                if (!value || (value === null || value === void 0 ? void 0 : value.length) < 10 || (value === null || value === void 0 ? void 0 : value.length) > 250) {
                    return "Observations length must be between 10 and 250 characters.";
                }
                else if ((value === null || value === void 0 ? void 0 : value.length) > 10) {
                    return '';
                }
                return '';
            }
        },
        onChange: onChange,
        isCollapsible: true,
        dataGridProps: {
            hideFooter: true,
            disableColumnMenu: true,
            checkboxSelection: true,
            slotProps: {
                toolbar: {
                    chipLabel: "".concat((_value$ParamsBeforeRe = value === null || value === void 0 || (_value$ParamsBeforeRe2 = value.ParamsBeforeRepairData) === null || _value$ParamsBeforeRe2 === void 0 ? void 0 : _value$ParamsBeforeRe2.length) !== null && _value$ParamsBeforeRe !== void 0 ? _value$ParamsBeforeRe : 0, "/5")
                }
            }
        },
        visibleActions: {
            advanceSearch: false,
            manageColumns: false,
            export: false,
            upload: false,
            add: ((value === null || value === void 0 || (_value$ParamsBeforeRe3 = value.ParamsBeforeRepairData) === null || _value$ParamsBeforeRe3 === void 0 ? void 0 : _value$ParamsBeforeRe3.length) || 0) < 5
        }
    });
};
